import { render, staticRenderFns } from "./ProjectProduction.vue?vue&type=template&id=70dd8b3d&"
import script from "./ProjectProduction.vue?vue&type=script&lang=js&"
export * from "./ProjectProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports